import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SyncIcon from "@mui/icons-material/Sync";

const SyncConfirmationModal = ({ open, onClose, onConfirm, loading = false }) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "10px",
          padding: "10px"
        }
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: "10px"
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: "18px",
            color: "#3A4252"
          }}
        >
          Sync Confirmation
        </Typography>
        {!loading && (
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              color: "#64748B"
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent sx={{ paddingTop: "10px", paddingBottom: "20px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "15px"
          }}
        >
          <Box
            sx={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              backgroundColor: "#ECF0FF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <SyncIcon sx={{ fontSize: "30px", color: "#605DFF" }} />
          </Box>

          <Typography
            variant="body1"
            sx={{
              fontSize: "16px",
              fontWeight: 500,
              color: "#3A4252",
              marginBottom: "5px"
            }}
          >
            Do you want to sync revenue and products from Shopify now?
          </Typography>

          <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              color: "#64748B"
            }}
          >
            This will fetch the latest data from your POS system.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          padding: "0 24px 20px 24px",
          justifyContent: "center",
          gap: "10px"
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={loading}
          sx={{
            borderRadius: "7px",
            padding: "10px 24px",
            fontSize: "14px",
            fontWeight: 500,
            textTransform: "none",
            borderColor: "#ECEEF2",
            color: "#64748B",
            "&:hover": {
              borderColor: "#605DFF",
              backgroundColor: "transparent"
            }
          }}
        >
          No, Skip
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={loading}
          sx={{
            borderRadius: "7px",
            padding: "10px 24px",
            fontSize: "14px",
            fontWeight: 500,
            textTransform: "none",
            backgroundColor: "#605DFF",
            color: "#fff",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#4936f5",
              boxShadow: "none"
            },
            "&:disabled": {
              backgroundColor: "#B1BBC8",
              color: "#fff"
            }
          }}
        >
          {loading ? "Starting Sync..." : "Yes, Sync Now"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SyncConfirmationModal;

